$("#blog_read_more").click(function(){
	amplitude.getInstance().logEvent('Blog read more button');
});

$("#callout_button").click(function(){
	amplitude.getInstance().logEvent('Callout first button click');
});

$("#callout_button2").click(function(){
	amplitude.getInstance().logEvent('Callout second button click');
});

$("a[href^='tel']").on("click",function(){
	amplitude.getInstance().logEvent('Phone number clicked');
});


/*
* Product Page
*/
$("#product-read-more").click(function(){
	amplitude.getInstance().logEvent('Product Page - Link - How To Choose The Right Company');
});

$(".product-nav .thumb-custom-mailer-box").click(function(){
	amplitude.getInstance().logEvent('Product Page - Thumbnail - Custom Mailer Box');
});

$(".product-nav .thumb-one-piece-folder-box").click(function(){
	amplitude.getInstance().logEvent('Product Page - Thumbnail - Folder Box');
});

$(".product-nav .thumb-shipping-box").click(function(){
	amplitude.getInstance().logEvent('Product Page - Thumbnail - Shipping Box');
});

$(".product-nav .thumb-triangle-document-mailer").click(function(){
	amplitude.getInstance().logEvent('Product Page - Thumbnail - Triangle Box');
});

$("#customboxquote").click(function(){
	amplitude.getInstance().logEvent('Product Page - Form - Custom Box Quote Form Submission');
});

$("#customquotemodal").click(function(){
	amplitude.getInstance().logEvent('Product Page - Link - Custom Box Quote Form');
});

$("#pricematchform").click(function(){
	amplitude.getInstance().logEvent('Product Page - Form - Price Match Form Submission');
});

$("#pricematchmodal").click(function(){
	amplitude.getInstance().logEvent('Product Page - Link - Price Match Form');
});

$("#dynamicmailerlink").click(function(){
	amplitude.getInstance().logEvent('Product Page - Link - Dynamic Mailer Clicked');
});

$("#dynamicshipperlink").click(function(){
	amplitude.getInstance().logEvent('Product Page - Link - Dynamic Shipper Clicked');
});



/*
* Design Showcase
*/
$("#showcase-start-custom-box-type").click(function(){
	amplitude.getInstance().logEvent('Design Showcase - Button - Start Custom Box');
});


/*
* Contact Us
*/
$("#contact-facebook").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Button - Facebook Social Icon');
});

$("#contact-linkedin").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Button - Linkedin Social Icon');
});

$("#contact-instagram").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Button - Instagram Social Icon');
});

$("#contact-twitter").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Button - Twitter Social Icon');
});

$("#contact_page_form_button").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Button - Submit');
});

$(".contact-link-view-all").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Link - Inside The Box View All');
});

$(".contact-link-view-all").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Link - Inside The Box View All');
});

$(".callout-select-box-style").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Link - Select Box Style');
});

$(".callout-view-design-showcase").click(function(){
	amplitude.getInstance().logEvent('Contact Us - Link - View Design Showcase');
});


/*
* Homepage
*/

$("#hero_lets_started").click(function(){
	amplitude.getInstance().logEvent('Home - Button - Let\'s Get Started');
});

$("#features_section_design_box").click(function(){
	amplitude.getInstance().logEvent('Home - Button - Design Your Box');
});

$("#home_start_your_design_mailer").click(function(){
	amplitude.getInstance().logEvent('Home - Button - Start Design Mailer Box');
});

$("#home_start_your_design_learn_more_mailer").click(function(){
	amplitude.getInstance().logEvent('Home - Link - Learn More Mailer Box');
});

$("#home_start_your_design_folder").click(function(){
	amplitude.getInstance().logEvent('Home - Button - Start Design Folder Box');
});

$("#home_start_your_design_learn_more_folder").click(function(){
	amplitude.getInstance().logEvent('Home - Link - Learn More Folder Box');
});

$("#home_start_your_design_shipping").click(function(){
	amplitude.getInstance().logEvent('Home - Button - Start Design Shipping Box');
});

$("#home_start_your_design_learn_more_shipping").click(function(){
	amplitude.getInstance().logEvent('Home - Link - Learn More Shipping Box');
});

$("#home_start_your_design_triangle").click(function(){
	amplitude.getInstance().logEvent('Home - Button - Start Design Triangle Box');
});

$("#home_start_your_design_learn_more_triangle").click(function(){
	amplitude.getInstance().logEvent('Home - Link - Learn More Triangle Box');
});

$("#home_blog_view_all").click(function(){
	amplitude.getInstance().logEvent('Home - Link - Inside The Box View All');
});

$("#read-more-what-you-should-know-about-custom-boxes").click(function(){
	amplitude.getInstance().logEvent('Home - Link - What You Should Know About Custom Boxes');
});

$("#read-more-how-to-choose-the-right-custom-box-company").click(function(){
	amplitude.getInstance().logEvent('Home - Link - How To Choose The Right Company');
});

$("#callout-explore-box-styles").click(function(){
	amplitude.getInstance().logEvent('Home - Button - Explore Box Styles');
});

$("#callout-start-designing-your-box").click(function(){
	amplitude.getInstance().logEvent('Home - Button - Start Designing Your Box');
});


/*
 * Header
 */
// header general

$("#header_sign_up").click(function(){
	amplitude.getInstance().logEvent('Header - Button - Sign Up');
});



// header topnav links
// NEW NAV
$(".header__content #menu-login").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Login');
});

$(".header__content #menu-get-started").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Get Started');
});

$(".nav__cart").click(function(){
	amplitude.getInstance().logEvent('Header - Link - View Cart');
});

$(".header__content #menu-showcase").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Design Showcase');
});

$(".header__content #menu-resources").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Resources');
});

$(".header__content #menu-design-a-custom-box").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Design & Order Box');
});


// header products dropdown
$(".header__content #mega-menu-mailer-box").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Custom Mailer');
});

$(".header__content #mega-menu-one-piece-folder-box").click(function(){
	amplitude.getInstance().logEvent('Header - Link - One Piece Folder');
});

$(".header__content #mega-menu-shipping-box").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Shipping Box');
});

$(".header__content #mega-menu-triangle-mailer").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Triangle Mailer');
});

$(".header__content #menu-resources-blog-view-all").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Blog');
});


$(".header__content #menu-resources-how-to-choose-the-right-custom-box-company").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Blog How To Choose The Right Company');
});

$(".header__content #menu-resources-what-you-should-know-about-custom-boxes").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Blog What You Should Know About Custom Boxes');
});

$(".header__content #menu-resources-how-does-product-packaging-influence-consumer-behavior").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Blog How Does Product Packaging Influence Consumer Behavior');
});

$(".header__content #menu-resources-what-is-environmentally-friendly-packaging").click(function(){
	amplitude.getInstance().logEvent('Header - Link - Blog What Is Environmentally Friendly Packaging');
});


// NEW resources Menu
$(".header__content .menu-faqs").click(function(){
	amplitude.getInstance().logEvent('Header - Link - FAQs');
});

$(".header__content #menu-resources-faq-view-all").click(function(){
	amplitude.getInstance().logEvent('Header - Link - FAQs');
});

$(".header__content #menu-resources-design-artwork").click(function(){
	amplitude.getInstance().logEvent('Header - Link - FAQ Design & Artwork');
});

$(".header__content #menu-resources-box-materials-printing").click(function(){
	amplitude.getInstance().logEvent('Header - Link - FAQ Box Materials & Printing');
});

$(".header__content #menu-resources-orders-pricing").click(function(){
	amplitude.getInstance().logEvent('Header - Link - FAQ Orders & Pricing');
});

$(".header__content #menu-resources-shipping").click(function(){
	amplitude.getInstance().logEvent('Header - Link - FAQ Shipping');
});

/*
 * Footer
 */
//footer general
$(".footer__notice-content a").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Send A Message');
});

$(".Button__FormStyledButton-p2mbjt-0").click(function(){
	amplitude.getInstance().logEvent('Footer - Button - Newsletter Signup');
});

// footer social icons
$(".footer__socials .facebook").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Facebook Social Icon');
});

$(".footer__socials .linkedin").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Linkedin Social Icon');
});

$(".footer__socials .instagram").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Instagram Social Icon');
});

$(".footer__socials .twitter").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Twitter Social Icon');
});

// footer customer service column
$(".footer__links .menu-contact-us").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Contact Us');
});

$(".footer__links .menu-inspiration").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Inspiration');
});

$(".footer__links .menu-faq").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - FAQ');
});


// footer company column
$(".footer__links .menu-about-us").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - About Us');
});

$(".footer__links .menu-blog").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Blog');
});

// footer products column
$(".footer__links .menu-custom-mailer-box").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Custom Mailer');
});

$(".footer__links .menu-one-piece-folder-box").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - One Piece Folder');
});

$(".footer__links .menu-shipping-box").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Shipping Box');
});

$(".footer__links .menu-triangle-document-mailer").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Triangle Mailer');
});

// footer info links
$(".footer__info .menu-privacy").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Privacy Policy');
});

$(".footer__info .menu-terms").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Terms');
});

$(".footer__info .menu-refund-policy").click(function(){
	amplitude.getInstance().logEvent('Footer - Link - Refund Policy');
});


/* FAQs */
$("#menu-resources-design-artwork").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Design & Artwork');
});

$("#menu-resources-how-do-i-design-offline").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - How do I design offline?');
});

$("#menu-resources-can-i-save-my-designs-to-finish-later").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Can I save my designs to finish later?');
});

$("#menu-resources-can-i-print-white-ink-on-my-box").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Can I print white ink on my box?');
});

$("#menu-resources-how-do-i-measure-a-box").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - How do I measure a box?');
});

$("#menu-resources-").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - ...');
});

$("#menu-resources-box-materials-printing").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Box Materials & Printing');
});

$("#menu-resources-what-is-high-definition-print").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - What is High Definition Print?');
});

$("#menu-resources-what-types-of-material-can-i-print-on").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - What types of material can I print on?');
});

$("#menu-resources-are-your-boxes-made-in-the-usa").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Are your boxes made in the USA?');
});

$("#menu-resources-are-you-using-sustainable-recyclable-material-and-safe-printing-practices").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Are you using sustainable, recyclable material and safe printing practices?');
});

$("#menu-resources-orders-pricing").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Orders & Pricing');
});

$("#menu-resources-how-can-i-track-the-status-of-my-order").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - How can I track the status of my Order?');
});

$("#menu-resources-can-you-offer-rush-production").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Can you offer rush production?');
});

$("#menu-resources-do-you-make-custom-inserts").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Do you make Custom Inserts?');
});

$("#menu-resources-how-can-i-get-in-touch-with-someone-about-my-order").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - How can I get in touch with someone about my order?');
});

$("#menu-resources-shipping").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Shipping');
});

$("#menu-resources-do-you-offer-rush-shipping").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Do you offer rush shipping?');
});

$("#menu-resources-can-you-ship-to-a-po-box").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Can you ship to a PO box?');
});

$("#menu-resources-where-does-my-order-ship-from").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - Where does my order ship from?');
});

$("#menu-resources-how-do-i-estimate-shipping-costs-before-placing-an-order").click(function(){
	amplitude.getInstance().logEvent('Header - FAQ - How do I estimate shipping costs before placing an order?');
});


$("#customize-and-buy").click(function(){
  
  var amplitudeTrackData = {"name": "{{ product.title }}", 
   "quantity": document.getElementById("product-QTY").value ,
   "sides": document.getElementById("product-Printing Side Options").value,
   "paper_type": document.querySelector('input[name="Paper Type"]:checked').value,
  }
  
  if( document.getElementById("product-Size") ) {
  	amplitudeTrackData[ 'size' ] = document.getElementById("product-Size").value
  }
  
    if( document.getElementById("length") ) {
  	amplitudeTrackData[ 'dynamic_size' ] = document.getElementById("length").value + "x" +
      document.getElementById("width").value + "x" +
      document.getElementById("depth").value;
  }
  
  
	amplitude.getInstance().logEvent('Product Page - Button - Customize & Buy', amplitudeTrackData);
});

$("#buy-and-checkout").click(function(){
  
  var amplitudeTrackData = {"name": "{{ product.title }}", 
   "quantity": document.getElementById("product-QTY").value ,
   "sides": document.getElementById("product-Printing Side Options").value,
   "paper_type": document.querySelector('input[name="Paper Type"]:checked').value
  }
  
  if( document.getElementById("product-Size") ) {
  	amplitudeTrackData[ 'size' ] = document.getElementById("product-Size").value
  }
  
      if( document.getElementById("length") ) {
  	amplitudeTrackData[ 'dynamic_size' ] = document.getElementById("length").value + "x" +
      document.getElementById("width").value + "x" +
      document.getElementById("depth").value;
  }
  
	amplitude.getInstance().logEvent('Product Page - Button - Order Now & Send Dieline', amplitudeTrackData);
});


$( document ).ready(function() {
  
  
  $("#product-QTY").change(function(){
	 amplitude.getInstance().logEvent('Product Page - Option - Change Quantity', { "new_value": this.value });
});
  
    $("#product-Size").change(function(){
	 amplitude.getInstance().logEvent('Product Page - Option - Change Box Size', { "new_value": this.value });
});

	    $("#product-Printing Side Options").change(function(){
	 amplitude.getInstance().logEvent('Product Page - Option - Change Print Side', { "new_value": this.value });
});  

  	    $("#product-tab-1").click(function(){
	 amplitude.getInstance().logEvent('Product Page - Panel - Materials');
});  

  $("#product-tab-2").click(function(){
	 amplitude.getInstance().logEvent('Product Page - Panel - Printing Options');
});  

  $("#product-tab-3").click(function(){
	 amplitude.getInstance().logEvent('Product Page - Panel - Best Practices');
});  
	  
}); 